import React from "react";
import { Dialog, Flex, Text, Button } from "@radix-ui/themes";

export function BrevoChoiceDialog({ isOpen, onOpenChange, data, onChoose }) {
  if (!data) return null;

  const { message, deleted_at, options = [] } = data;

  const choiceLabels = {
    resume: "Resume Syncing",
    continue_from_now: "Continue from Now",
    sync_all_historical: "Sync All Historical Contacts",
  };

  const descriptionText =
    options.includes("sync_all_historical")
      ? "Would you like to resume syncing, start fresh from now, or sync all historical contacts?"
      : "Would you like to resume syncing from before deletion or start fresh from now?";

  return (
    <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
      <Dialog.Content maxWidth="500px">
        <Dialog.Title>Previous Brevo Integration Detected</Dialog.Title>

        <Dialog.Description size="2" mb="4">
          {message}
          {deleted_at && (
            <>
              <br />
              Last deleted on: <strong>{new Date(deleted_at).toLocaleString()}</strong>
            </>
          )}
          <br />
          {descriptionText}
        </Dialog.Description>

        <Flex justify="end" gap="3">
          {options.map((opt) => (
            <Button
              key={opt}
              variant={opt === "resume" ? "soft" : "outline"}
              color={opt === "resume" ? "accent" : "gray"}
              onClick={() => onChoose(opt)}
              style={{ flexShrink: 1, minHeight: "44px" }}
            >
              {choiceLabels[opt]}
            </Button>
          ))}
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
}
